/**
 * Visually Hidden component
 *
 * Used to hide text from visual users while keeping the content available
 * for screen reader users
 */
import React from 'react';
import PropTypes from 'prop-types';
import {generateTestIds} from '@homebase/common';
import './VisuallyHidden.$BRAND.css.js';

export default function VisuallyHidden({is: Component, testIds, ...props}) {
  return (
    <Component
      {...props}
      {...generateTestIds({testIds})}
      className="pl-VisuallyHidden"
      data-hb-id="VisuallyHidden"
    />
  );
}

VisuallyHidden.propTypes = {
  // An HTML element used to render the text
  is: PropTypes.string,
  // The accessibly hidden content - this is what the screen reader will read out
  children: PropTypes.node.isRequired,
  // Optional Enzyme and Codeception testing identifiers
  testIds: PropTypes.shape({
    enzyme: PropTypes.string,
    codeception: PropTypes.string,
  }),
};

VisuallyHidden.defaultProps = {
  is: 'span',
  testIds: {},
};
